module.exports = __webpack_public_path__ + "img/hic-infectious-diseases-female.abab1003.png";